import { keyFactory } from "@/api/keyFactory";
import { nestErrorMessage } from "@/api/nest-error";
import { useMutationPayementTransferStatus } from "@/api/payement/payement";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

interface UsePayementTransferStatusProps {
  candidateId: number;
  successMessage: string;
  onSuccess: () => void;
}

const usePayementTransferStatus = ({
  candidateId,
  successMessage,
  onSuccess,
}: UsePayementTransferStatusProps) => {
  const queryClient = useQueryClient();

  return useMutationPayementTransferStatus({
    onSuccess: () => {
      toast.success(successMessage);

      [
        keyFactory.candidate.onGoingRegistration(candidateId),
        keyFactory.exam.base(),
        keyFactory.registration.base(),
      ].forEach((queryKey) => queryClient.invalidateQueries({ queryKey }));

      onSuccess();
    },
    onError: (error) =>
      toast.error("Échec de la requête", {
        description: nestErrorMessage(error),
      }),
  });
};

export default usePayementTransferStatus;
